(function(window, $){


    var CollectionSidebar = {


        init: function(){
            var me = this;
            me.initCheckboxChekced();
            me.toggleMobileFilters();

            $(".filters-sidebar .filter-row.disabled").on("click", function(e){
                e.preventDefault();
                return false;
            });
        },


        initCheckboxChekced: function()
        {

            $(".filters-sidebar .filter-row:not(.disabled) .filter-checkbox").on("change", function(){
                var elem = $(this);
                var filter_link = elem.parent().attr("href");
                var url_to_remove = elem.parent().attr("data-url-to-remove");
                if(!elem.is(":checked") && url_to_remove) {
                    filter_link = url_to_remove;
                }

                window.location.href = filter_link;

            });

        },



        toggleMobileFilters: function()
        {

            var me = this;

            $(".filters-sidebar .open-filters").on("click", function(){
                var elem = $(this);
                if(elem.hasClass("active")) {
                    $(".filters-sidebar .open-filters, .filters-sidebar .collection-filters-wrap, .filters-sidebar .filter-type-wrap.cats-filter")
                    .removeClass("active");
                    $(elem.attr("data-filters-wrap")).removeClass("active");
                    $(".filters-bg").removeClass("active");
                }else{
                    $(".filters-sidebar .open-filters, .filters-sidebar .collection-filters-wrap, .filters-sidebar .filter-type-wrap.cats-filter")
                    .removeClass("active");
                    elem.addClass("active");
                    $(elem.attr("data-filters-wrap")).addClass("active");
                    $(".filters-bg").addClass("active");
                }
                
                
            });


            $(".filters-sidebar .filter-title").on("click", function(e){
                var is_mobile = window.matchMedia("(max-width: 991px)");
                if(is_mobile.matches) {
                    var elem = $(this);
                    elem.toggleClass("inactive");
                    elem.parent().find(".filter-items").slideToggle();
                }
                
            });

            

            $(".filter-type-wrap").on("click", function(e){
                e.stopPropagation();
            });

            $(".filters-bg").on("click", function(){
                me.closeFilters();
            });


            $(document).click(function(){
                $(".filters-sidebar .filter-title.active").removeClass("active");
                $(".filters-sidebar .filter-items.active").removeClass("active");
            });


        },


        closeFilters: function(){
            $(".filters-sidebar .open-filters, .filters-sidebar .collection-filters-wrap, .filters-sidebar .filter-type-wrap.cats-filter")
                    .removeClass("active");
            $(".filters-bg").removeClass("active");
        }


    };


    $(document).ready(function(){
        CollectionSidebar.init();
    });


})(window, jQuery);